import { IconAd2, IconBrandGoogleAnalytics, IconBrandHipchat, IconBrandMeta, IconId, IconLayoutNavbar, IconLifebuoy, IconLink, IconLogout, IconQrcode, IconReceipt2, IconSmartHome, IconTrophy, IconUserCode, IconUserCog, IconUserScan, IconUserStar } from '@tabler/icons-react';
import { memo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { accessKeys } from '../../statics/accessKeys';
import { PROFILE } from '../../statics/localStorage';
import { accessCheck } from '../../utils/accessCheck';
import { checkDomain } from '../../utils/domainCheck.util';
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";

const SideMenu = memo(function SideMenu({ isOpen }) {

    const { pathname } = useLocation();
    const navigate = useNavigate();
    const profileData = PROFILE();

    const menuItems = [
        {
            id: 1,
            name: 'Dashboard',
            link: '/dashboard',
            icon: <IconSmartHome size={20} />,
            active: pathname == ('/dashboard'),
            // access: (accessCheck(accessKeys.getTotalNewsCount) || accessCheck(accessKeys.getTotalShareCount) || accessCheck(accessKeys.getTotalLikeCount) || accessCheck(accessKeys.getTotalViewsCount) || accessCheck(accessKeys.getTotalUserCount) || accessCheck(accessKeys.getAllPollCount))
            access: checkDomain() === "app",
        }, {
            id: 2,
            name: 'Link',
            icon: <IconLink size={20} />,
            link: '/links-list',
            active: pathname.includes('link'),
            access: (checkDomain() === "app" && accessCheck(accessKeys.viewLinkList))
        }, {
            id: 3,
            name: 'QR Code',
            link: '/qr-codes',
            icon: <IconQrcode size={20} />,
            active: pathname.includes('qr-codes'),
            access: (checkDomain() === "app" && accessCheck(accessKeys.viewQrList))
        }, {
            id: 4,
            name: 'Pages',
            link: '/pages',
            icon: <IconLayoutNavbar size={20} />,
            active: pathname.includes('page'),
            access: checkDomain() === "app" && accessCheck(accessKeys.viewPageList)
        }, {
            id: 5,
            name: 'Digital Business Card',
            link: '/business-cards',
            icon: <IconId size={20} />,
            active: pathname.includes('business-card'),
            access: checkDomain() === "app" && accessCheck(accessKeys.viewBusinessCardList)
        }, {
            id: 6,
            name: 'Meta Ads',
            link: '/meta-ads',
            icon: <IconBrandMeta size={20} />,
            active: pathname.includes('meta-ads'),
            access: checkDomain() === "app" && accessCheck(accessKeys.viewMetaAnalytics)
        }, {
            id: 7,
            name: 'Google Ads',
            link: '/google-analytics',
            icon: <IconBrandGoogleAnalytics size={20} />,
            active: pathname.includes('google-analytics'),
            access: checkDomain() === "app" && accessCheck(accessKeys.viewGoogleAdsAnalytics),
        }, {
            id: 8,
            name: 'Agents',
            link: '/agents',
            icon: <IconUserScan size={20} />,
            active: pathname.includes('agent'),
            access: (checkDomain() === "app" && profileData?.planRequestStatus == 3 && accessCheck(accessKeys.viewAgentDetails)),
        }, {
            id: 9,
            name: 'Influencers',
            link: '/influencers',
            icon: <IconUserStar size={20} />,
            active: pathname.includes('influencer'),
            access: (checkDomain() === "app" && profileData?.planRequestStatus == 3 && accessCheck(accessKeys.viewInfluencerDetails)),
        }, {
            id: 10,
            name: 'Promotions',
            link: '/promotions',
            icon: <IconAd2 size={20} />,
            active: pathname.includes('promotion'),
            access: (checkDomain() === "app" && profileData?.planRequestStatus == 3 && accessCheck(accessKeys.createAndUpdatePromotion))
        }, {
            id: 11,
            name: 'Developer Section',
            link: '/developer-section',
            icon: <IconUserCode size={20} />,
            active: pathname.includes('developer-section'),
            access: (checkDomain() === "app" && accessCheck(accessKeys.viewProductAndAppDetails)),
        }, {
            id: 12,
            name: 'Live Chat',
            link: (typeof profileData?.currentPlanId === "undefined" || profileData?.currentPlanId === null) ? '/pricing-plan' : '/live-chat',
            icon: <IconBrandHipchat size={20} />,
            active: (typeof profileData?.currentPlanId === "undefined" || profileData?.currentPlanId === null) ? pathname.includes('pricing-plan') : pathname.includes('live-chat'),
            access: (typeof profileData?.currentPlanId === "undefined" || profileData?.currentPlanId === null) ? accessCheck(accessKeys.chatPriceAndPlan) : (checkDomain() === "chat" && accessCheck(accessKeys.createAndUpdateChatSession)),
        }, {
            id: 13,
            name: 'Account Settings',
            link: '/settings',
            icon: <IconUserCog size={20} />,
            active: pathname.includes('settings'),
            // access: accessCheck(accessKeys.getAdminList),
            access: true,
        }, {
            id: 14,
            name: 'Price & Plan',
            link: '/pricing-plan',
            icon: <IconReceipt2 size={20} />,
            active: pathname.includes('pricing-plan'),
            access: (typeof profileData?.currentPlanId === "undefined" || profileData?.currentPlanId === null) ? false : accessCheck(accessKeys.chatPriceAndPlan)
        }, {
            id: 15,
            name: 'Rewards & Refer',
            link: '/rewards-&-refer',
            icon: <IconTrophy size={20} />,
            active: pathname.includes('rewards'),
            access: profileData?.role == 1 && checkDomain() === "app"
        }, {
            id: 16,
            name: 'Support',
            link: '/support',
            icon: <IconLifebuoy size={20} />,
            active: pathname.includes('support'),
            access: true
        }
    ];

    async function onLogout() {
        loadingShow();
        let resp = await getApi(urlApi.logOut);
        loadingHide();
        if (resp.responseCode === 200) {
            localStorage.removeItem('advy-token');
            localStorage.removeItem('admin-access-list');
            localStorage.removeItem('advy-a-l-t');
            // localStorage.removeItem('meta-account');
            // localStorage.removeItem('google-account');
            navigate('/login');
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <aside className="sidebar h-screen bg-white absolute z-50"
            style={{ width: "260px", transition: 'all 0.3s ease-in-out', left: isOpen ? 0 : '-260px' }}>

            <Link to={checkDomain() === "app" ? '/dashboard' : checkDomain() === "chat" ? '/live-chat' : ''}>  <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="logo" className='pt-[12px] mb-6 mx-auto px-8 h-8' /></Link>

            <div className="menu-items overflow-y-auto overflow-x-hidden px-4" style={{ height: 'calc(100% - 85px )' }}>
                {
                    menuItems?.filter(item => item.access)?.map((menu, _) => {
                        return (
                            (menu.access) && <Link to={menu.link} key={menu.id} className={`flex items-center px-[20px] py-[12px] text-sm font-medium no-underline rounded-[18px] text-[var(--secondary-text)] mb-2 ${!menu?.active && 'hover:bg-[var(--secondary)] hover:text-white'} transition-all ${menu?.active ? 'sidebar-active' : ''}`} >
                                <span> {menu.icon}</span>
                                <span className="ml-2">{menu.name}</span>
                            </Link>)
                    })
                }
                <ConfirmationModal
                    buttonComponent={<div className="flex items-center px-[24px] py-[12px] text-md rounded-[18px] font-medium mb-2 text-[var(--secondary-text)] hover:bg-[var(--cancel)] hover:text-white transition-all" >
                        <IconLogout size={20} />
                        <span className="ml-2 text-sm">Logout</span>
                    </div>}
                    confirmationText={`Are You Sure Want To Logout ?`}
                    onConfirm={() => onLogout()}
                />
            </div>

        </aside>
    )
})

export default SideMenu